import api from "../../../api/api";

/** Account Management (Root Admin) */
export const listAccounts = (params) => api.get("/root/accounts", { params });

export const getAccountDetail = (u_id) =>
  api.get(`/root/accounts/${encodeURIComponent(u_id)}`);

export const getOrganizationsOverview = () =>
  api.get(`/root/accounts/organizations/overview`);

export const deleteAccount = (u_id, body) =>
  api.post(`/root/accounts/${encodeURIComponent(u_id)}/delete`, body);

export const resetAccountPassword = (u_id, body) =>
  api.post(`/root/accounts/${encodeURIComponent(u_id)}/reset-password`, body);

export const resetAccount2fa = (u_id, body) =>
  api.post(`/root/accounts/${encodeURIComponent(u_id)}/reset-2fa`, body);

export const resendAccountVerification = (u_id, body) =>
  api.post(
    `/root/accounts/${encodeURIComponent(u_id)}/resend-verification`,
    body,
  );

/** Sub-user management (Root Admin assisted) */
export const inviteSubUser = (admin_id, body) =>
  api.post(`/root/accounts/${encodeURIComponent(admin_id)}/sub-users`, body);

export const updateSubUser = (u_id, body) =>
  api.post(`/root/accounts/sub-users/${encodeURIComponent(u_id)}/update`, body);

export const deleteSubUser = (u_id, body) =>
  api.post(`/root/accounts/sub-users/${encodeURIComponent(u_id)}/delete`, body);

export const convertSubUserToSubsidiary = (u_id, body) =>
  api.post(
    `/root/accounts/sub-users/${encodeURIComponent(u_id)}/convert-to-subsidiary`,
    body,
  );

/** Subsidiary management (Root Admin assisted) */
export const listSubsidiaries = (admin_id) =>
  api.get(`/root/accounts/${encodeURIComponent(admin_id)}/subsidiaries`);

export const inviteSubsidiary = (admin_id, body) =>
  api.post(`/root/accounts/${encodeURIComponent(admin_id)}/subsidiaries`, body);

export const updateSubsidiary = (u_id, body) =>
  api.post(
    `/root/accounts/subsidiaries/${encodeURIComponent(u_id)}/update`,
    body,
  );

export const deleteSubsidiary = (u_id, body) =>
  api.post(
    `/root/accounts/subsidiaries/${encodeURIComponent(u_id)}/delete`,
    body,
  );

export const convertSubsidiaryToUser = (u_id, body) =>
  api.post(
    `/root/accounts/subsidiaries/${encodeURIComponent(u_id)}/convert-to-user`,
    body,
  );
